import { render } from "./SpeakerKit.vue?vue&type=template&id=628be9c3&scoped=true"
import script from "./SpeakerKit.vue?vue&type=script&lang=js"
export * from "./SpeakerKit.vue?vue&type=script&lang=js"

import "./SpeakerKit.vue?vue&type=style&index=0&id=628be9c3&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628be9c3"]])

export default __exports__